import { DefinedRangeType } from "../MultiRangeCalendar.domain"
import {
	CUSTOM_RANGES_ID,
	MOBILE_YEAR_PRESET_ID,
	MONTH_PRESET_ID,
	CURRENT_QUARTER_VS_LAST_YEAR,
	QUARTER_PRESET_ID,
	SEMESTER_PRESET_ID,
	WEEK_PRESET_ID,
	YEAR_PRESET_ID,
	MOBILE_QUARTER_VS_LAST_YEAR,
	MONTH_DATE_VS_LAST_YEAR,
	MOBILE_MONTH_VS_LAST_YEAR,
} from "../constants"
import {
	presetCustomRanges,
	presetMobileMonthVsLastYear,
	presetMobileQuarterVsLastYear,
	presetMobileYearPeriod,
	presetMonthPeriod,
	presetMonthVsLastYear,
	presetQuarterLastYear,
	presetQuarterPeriod,
	presetSemesterPeriod,
	presetWeekPeriod,
	presetYearPeriod,
} from "./utils/utils"

export const WEEK_PRESET: DefinedRangeType = {
	id: WEEK_PRESET_ID,
	label: "phronesis.rangecalendar.defaultpreset.week",
	isSelected: false,
	fn: () => presetWeekPeriod(),
}

export const MONTH_PRESET: DefinedRangeType = {
	id: MONTH_PRESET_ID,
	label: "phronesis.rangecalendar.defaultpreset.month",
	isSelected: false,
	fn: () => presetMonthPeriod(),
}

export const QUARTER_PRESET: DefinedRangeType = {
	id: QUARTER_PRESET_ID,
	label: "phronesis.rangecalendar.defaultpreset.quarter",
	isSelected: false,
	fn: () => presetQuarterPeriod(),
}

export const SEMESTER_PRESET: DefinedRangeType = {
	id: SEMESTER_PRESET_ID,
	label: "phronesis.rangecalendar.defaultpreset.semester",
	isSelected: false,
	fn: () => presetSemesterPeriod(),
}

export const YEAR_PRESET: DefinedRangeType = {
	id: YEAR_PRESET_ID,
	label: "phronesis.rangecalendar.defaultpreset.year",
	isSelected: false,
	fn: () => presetYearPeriod(),
}

export const CUSTOM_RANGES_PRESET: DefinedRangeType = {
	id: CUSTOM_RANGES_ID,
	label: "phronesis.rangecalendar.defaultpreset.customranges",
	isSelected: false,
	fn: () => presetCustomRanges(),
}

export const MOBILE_YEAR_PRESET: DefinedRangeType = {
	id: MOBILE_YEAR_PRESET_ID,
	label: "phronesis.rangecalendar.defaultpreset.mobile.year",
	isSelected: false,
	fn: () => presetMobileYearPeriod(),
}

export const CURRENT_QUARTER_VS_LAST_YEAR_PRESET = {
	id: CURRENT_QUARTER_VS_LAST_YEAR,
	label: "phronesis.rangecalendar.defaultpreset.current-quarter-vs-last-year",
	isSelected: false,
	fn: () => presetQuarterLastYear(),
}

export const MOBILE_QUARTER_VS_LAST_YEAR_PRESET = {
	id: MOBILE_QUARTER_VS_LAST_YEAR,
	label:
		"phronesis.rangecalendar.defaultpreset.mobile.current-quarter-vs-last-year",
	isSelected: false,
	fn: () => presetMobileQuarterVsLastYear(),
}

export const MONTH_DATE_VS_LAST_YEAR_PRESET = {
	id: MONTH_DATE_VS_LAST_YEAR,
	label: "phronesis.rangecalendar.defaultpreset.month-vs-last-year",
	isSelected: false,
	fn: () => presetMonthVsLastYear(),
}

export const MOBILE_MONTH_VS_LAST_YEAR_PRESET = {
	id: MOBILE_MONTH_VS_LAST_YEAR,
	label: "phronesis.rangecalendar.defaultpreset.mobile.month-vs-last-year",
	isSelected: false,
	fn: () => presetMobileMonthVsLastYear(),
}

export const presetsRanges = [
	WEEK_PRESET,
	MONTH_PRESET,
	QUARTER_PRESET,
	SEMESTER_PRESET,
	YEAR_PRESET,
	MOBILE_YEAR_PRESET,
	CUSTOM_RANGES_PRESET,
	CURRENT_QUARTER_VS_LAST_YEAR_PRESET,
	MOBILE_QUARTER_VS_LAST_YEAR_PRESET,
	MONTH_DATE_VS_LAST_YEAR_PRESET,
]
